import * as yup from 'yup';

// Environment variables schema definition
const envSchema = yup
  .object({
    VITE_NODE_ENV: yup.string().required(),
    // Branding
    VITE_BRANDING: yup.string().required(),
    VITE_ENVIRONMENT: yup.string().optional(),
    // Flagsmith
    VITE_REACT_APP_FLAGS_ENV_KEY: yup.string().required(),
    // INTERNAL URL
    VITE_REACT_APP_API_URL: yup.string().required(),
    VITE_CDN_URL: yup.string().required(),
    VITE_BFF_URL: yup.string().required(),

    // ANALYTICS
    VITE_REACT_APP_FB_CONFIG_JSON: yup.string().optional(),
    VITE_MS_CLARITY_PROJECT_ID: yup.string().optional(),
    VITE_HOTJAR_SITE_ID: yup
      .number()
      .transform((_value: unknown, originalValue: string) => {
        return originalValue === '' ? undefined : Number(originalValue);
      })
      .optional(),
    VITE_HOTJAR_VERSION: yup
      .number()
      .transform((_value: unknown, originalValue: string) => {
        return originalValue === '' ? 6 : Number(originalValue);
      })
      .default(6),
    // GCP
    VITE_REACT_APP_GOOGLE_MAPS_API_KEY: yup.string().required(),

    // SENTRY
    VITE_SENTRY_ORG: yup.string().optional(),
    VITE_SENTRY_PROJECT: yup.string().optional(),
    VITE_SENTRY_AUTH_TOKEN: yup.string().optional(),
    VITE_SENTRY_ENVIRONMENT: yup.string().optional(),
    VITE_SENTRY_DSN: yup.string().optional(),
  })
  .required();

// Validation function that also types the return
function validateEnv(env: NodeJS.ProcessEnv): yup.InferType<typeof envSchema> {
  try {
    const validatedEnv = envSchema.validateSync(env, { abortEarly: false });
    return validatedEnv;
  } catch (error: unknown) {
    if (error instanceof yup.ValidationError) {
      // eslint-disable-next-line no-console
      console.error('❌ Environment validation failed:');
      const validationError = error as yup.ValidationError;
      validationError.inner.forEach((err: yup.ValidationError) => {
        // eslint-disable-next-line no-console
        console.error(`  - ${err.path}: ${err.message}`);
      });
    }
    throw error;
  }
}

// Validate and export environment variables
export const env = validateEnv(import.meta.env);
